import { render, staticRenderFns } from "./DialogDeleteDepartment.vue?vue&type=template&id=03582969&scoped=true&"
import script from "./DialogDeleteDepartment.vue?vue&type=script&lang=ts&"
export * from "./DialogDeleteDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./DialogDeleteDepartment.vue?vue&type=style&index=0&id=03582969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03582969",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VRow})
